(() => {
  'use strict';

  if (window.minicartRecommendationsInitialized) return;
  window.minicartRecommendationsInitialized = true;

  const CONFIG = {
    heading: 'You may also like',
    limit: 2,
    recommendationIntent: 'related',

    /*
     * This mirrors your current automatic Shopify discount for display only.
     * Change to 0 to show regular prices without a strike-through.
     */
    automaticDiscountEnabled:
  window.StorefrontDiscountPreview?.enabled || false,

automaticDiscountPercentage:
  Number(
    window.StorefrontDiscountPreview?.percentage || 0
  ),

    selectors: {
      minicart: '.minicart',
      productList: '.minicart-product-list',
      recommendationSection: '[data-minicart-recommendations]'
    }
  };

  const state = {
    loading: false,
    lastCartSignature: '',
    lastSeedProductId: null
  };

  const getRootUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const getCartUrl = () => `${getRootUrl()}cart.js`;

  const getRecommendationsUrl = (productId) => {
    const params = new URLSearchParams({
      product_id: String(productId),
      limit: '10',
      intent: CONFIG.recommendationIntent
    });

    return `${getRootUrl()}recommendations/products.json?${params.toString()}`;
  };

  const formatMoney = (cents) => {
    const value = Number(cents || 0);

    if (
      window.Shopify?.formatMoney &&
      window.theme?.moneyFormat
    ) {
      return window.Shopify.formatMoney(
        value,
        window.theme.moneyFormat
      );
    }

    const currency =
      window.Shopify?.currency?.active ||
      document.documentElement.dataset.currency ||
      'AUD';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format(value / 100);
    } catch (error) {
      return `$${(value / 100).toFixed(2)}`;
    }
  };

  const calculateDiscountedPrice = (price) => {
    const percentage = Number(
      CONFIG.automaticDiscountPercentage || 0
    );

    if (percentage <= 0) return Number(price || 0);

    /*
     * Calculate the discount amount first to mirror Shopify's
     * cents-based discount rounding.
     */
    const discountAmount = Math.floor(
      (Number(price || 0) * percentage) / 100
    );

    return Number(price || 0) - discountAmount;
  };

  const isDiscountExcluded = (productId) => {

  return Boolean(
    window.StorefrontDiscountExcludedProducts?.[
      String(productId)
    ]
  );

};

  const escapeHtml = (value) =>
    String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const getImageUrl = (product) => {
    const image =
      typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image?.url ||
          product.featured_image?.src ||
          product.images?.[0];

    if (!image) return '';

    return image
      .replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_240x240$1$2');
  };

  const getAvailableVariants = (product) => {
    const variants = Array.isArray(product.variants)
      ? product.variants.filter((variant) => variant.available)
      : [];
    const hasPaidVariant = variants.some((variant) => Number(variant.price) > 0);
    if (!hasPaidVariant) return variants;
    return variants.filter((variant) => Number(variant.price) > 0);
  };

  const productNeedsProductPage = (product) => {
    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) =>
          String(
            typeof option === 'string' ? option : option.name
          ).toLowerCase()
        )
      : [];

    return optionNames.some(
      (name) =>
        name.includes('personalisation') ||
        name.includes('personalization')
    );
  };

  const getCart = async () => {
    const response = await fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('The cart could not be loaded.');
    }

    return response.json();
  };

  const getRecommendations = async (productId) => {
    const response = await fetch(
      getRecommendationsUrl(productId),
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Product recommendations could not be loaded.');
    }

    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  };

  const waitForBluboltAddToCart = (
    timeoutMilliseconds = 5000
  ) =>
    new Promise((resolve, reject) => {
      const startedAt = Date.now();

      const check = () => {
        if (typeof window.blubolt?.addToCart === 'function') {
          resolve(window.blubolt.addToCart);
          return;
        }

        if (Date.now() - startedAt >= timeoutMilliseconds) {
          reject(
            new Error(
              'The theme add-to-cart function is not available.'
            )
          );
          return;
        }

        window.setTimeout(check, 100);
      };

      check();
    });

  const buildVariantOptions = (variants, selectedVariantId) =>
    variants
      .map((variant) => {
        const selected =
          Number(variant.id) === Number(selectedVariantId)
            ? ' selected'
            : '';

        const variantTitle = String(variant.title || '');
        const envelopeTitle = variantTitle
          .split('/')
          .map((part) => part.trim().toLowerCase().replace(/\s+/g, ' '))
          .some((part) => part === '1 envelope' || part === '1 envolope');

        return `
          <option
            value="${escapeHtml(variant.id)}"
            data-price="${escapeHtml(variant.price)}"
            data-variant-title="${escapeHtml(variantTitle)}"
            ${
              envelopeTitle
                ? `data-one-envelope-variant="${escapeHtml(variant.id)}"`
                : ''
            }
            ${selected}
          >
            ${escapeHtml(variant.title)} – ${escapeHtml(
              formatMoney(variant.price)
            )}
          </option>
        `;
      })
      .join('');

  const buildPriceHtml = (
  price,
  productId
) => {

  const excluded =
    isDiscountExcluded(productId);


  const percentage =
    Number(
      CONFIG.automaticDiscountPercentage || 0
    );


  if (
    excluded ||
    !CONFIG.automaticDiscountEnabled ||
    percentage <= 0
  ) {

    return `
      <span class="minicart-recommendation-price__current">
        ${escapeHtml(formatMoney(price))}
      </span>
    `;
  }


  const discountedPrice =
    calculateDiscountedPrice(price);


  return `
    <span class="minicart-recommendation-price__discount">
      ${escapeHtml(percentage)}% OFF
    </span>

    <s class="minicart-recommendation-price__original">
      ${escapeHtml(formatMoney(price))}
    </s>

    <span class="minicart-recommendation-price__current">
      ${escapeHtml(formatMoney(discountedPrice))}
    </span>
  `;
};

  const buildProductCard = (product) => {
    const variants = getAvailableVariants(product);
    const firstVariant = variants[0];

    if (!firstVariant) return '';

    const imageUrl = getImageUrl(product);
    const mustVisitProductPage = productNeedsProductPage(product);

    const variantSelector =
      variants.length > 1 && !mustVisitProductPage
        ? `
          <label class="visually-hidden" for="MiniCartRecVariant-${escapeHtml(
            product.id
          )}">
            Select an option
          </label>
          <select
            id="MiniCartRecVariant-${escapeHtml(product.id)}"
            class="minicart-recommendation__variant"
            data-minicart-recommendation-variant
          >
            ${buildVariantOptions(variants, firstVariant.id)}
          </select>
        `
        : '';

    const action = mustVisitProductPage
      ? `
        <a
          class="minicart-recommendation__button"
          href="${escapeHtml(product.url)}"
        >
          CHOOSE OPTIONS
        </a>
      `
      : `
        <button
          type="button"
          class="minicart-recommendation__button"
          data-minicart-recommendation-add
          data-variant-id="${escapeHtml(firstVariant.id)}"
          data-variant-title="${escapeHtml(firstVariant.title)}"
          ${
            String(firstVariant.title || '')
              .split('/')
              .map((part) => part.trim().toLowerCase().replace(/\s+/g, ' '))
              .some((part) => part === '1 envelope' || part === '1 envolope')
              ? `data-one-envelope-variant="${escapeHtml(firstVariant.id)}" data-one-envelope-product="${escapeHtml(product.id)}"`
              : ''
          }
        >
          ADD
        </button>
      `;

    return `
      <article
        class="minicart-recommendation"
        data-minicart-recommendation-card
        data-product-id="${escapeHtml(product.id)}"
      >
        <a
          href="${escapeHtml(product.url)}"
          class="minicart-recommendation__image-link"
          aria-label="${escapeHtml(product.title)}"
        >
          ${
            imageUrl
              ? `
                <img
                  class="minicart-recommendation__image"
                  src="${escapeHtml(imageUrl)}"
                  alt="${escapeHtml(product.title)}"
                  loading="lazy"
                  width="120"
                  height="120"
                >
              `
              : ''
          }
        </a>

        <div class="minicart-recommendation__content">
          <a
            href="${escapeHtml(product.url)}"
            class="minicart-recommendation__title"
          >
            ${escapeHtml(product.title)}
          </a>

          <div
            class="minicart-recommendation__price"
            data-minicart-recommendation-price
          >
           ${buildPriceHtml(
  firstVariant.price,
  product.id
)}
          </div>

          ${variantSelector}
          ${action}

          <p
            class="minicart-recommendation__message"
            data-minicart-recommendation-message
            role="status"
            aria-live="polite"
            hidden
          ></p>
        </div>
      </article>
    `;
  };

  const renderRecommendations = (
    productList,
    products,
    cartSignature,
    seedProductId
  ) => {
    productList
      .parentElement
      ?.querySelector(CONFIG.selectors.recommendationSection)
      ?.remove();

    if (!products.length) return;

    const section = document.createElement('section');
    section.className = 'minicart-recommendations';
    section.dataset.minicartRecommendations = '';
    section.dataset.cartSignature = cartSignature;
    section.dataset.seedProductId = String(seedProductId);

    section.innerHTML = `
      <h4 class="minicart-recommendations__heading">
        ${escapeHtml(CONFIG.heading)}
      </h4>

      <div class="minicart-recommendations__grid">
        ${products.map(buildProductCard).join('')}
      </div>
    `;

    productList.insertAdjacentElement('afterend', section);
  };

  const injectRecommendations = async () => {
    const minicart = document.querySelector(
      CONFIG.selectors.minicart
    );

    const productList = minicart?.querySelector(
      CONFIG.selectors.productList
    );

    if (!minicart || !productList || state.loading) return;

    state.loading = true;

    try {
      const cart = await getCart();

      const visibleCartItems = (cart.items || []).filter(
        (item) => !item.properties?._childOfBundle
      );

      if (!visibleCartItems.length) return;

      const cartProductIds = new Set(
        (cart.items || []).map((item) => Number(item.product_id))
      );

      const cartSignature = (cart.items || [])
        .map(
          (item) =>
            `${item.key}:${item.quantity}:${item.final_line_price}`
        )
        .join('|');

      const seedProductId = Number(
        visibleCartItems[0].product_id
      );

      const existingSection = minicart.querySelector(
        CONFIG.selectors.recommendationSection
      );

      if (
        existingSection &&
        existingSection.dataset.cartSignature === cartSignature &&
        Number(existingSection.dataset.seedProductId) ===
          seedProductId
      ) {
        return;
      }

      const recommendedProducts = await getRecommendations(
        seedProductId
      );

      const filteredProducts = recommendedProducts
        .filter(
          (product) =>
            product.available &&
            !cartProductIds.has(Number(product.id)) &&
            getAvailableVariants(product).length > 0
        )
        .slice(0, CONFIG.limit);

      state.lastCartSignature = cartSignature;
      state.lastSeedProductId = seedProductId;

      renderRecommendations(
        productList,
        filteredProducts,
        cartSignature,
        seedProductId
      );
    } catch (error) {
      console.error(
        'Mini-cart recommendation error:',
        error
      );
    } finally {
      state.loading = false;
    }
  };

  const updateCardPrice = (select) => {
    const card = select.closest(
      '[data-minicart-recommendation-card]'
    );

    const selectedOption = select.selectedOptions?.[0];
    if (!card || !selectedOption) return;

    const price = Number(selectedOption.dataset.price || 0);
    const priceElement = card.querySelector(
      '[data-minicart-recommendation-price]'
    );

    const addButton = card.querySelector(
      '[data-minicart-recommendation-add]'
    );

    if (priceElement) {
      priceElement.innerHTML =
  buildPriceHtml(
    price,
    card.dataset.productId
  );
    }

    if (addButton) {
      addButton.dataset.variantId = select.value;
    }
  };

  const setCardMessage = (
    card,
    message = '',
    isError = false
  ) => {
    const messageElement = card.querySelector(
      '[data-minicart-recommendation-message]'
    );

    if (!messageElement) return;

    messageElement.textContent = message;
    messageElement.hidden = !message;
    messageElement.classList.toggle(
      'is-error',
      isError
    );
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest(
      '[data-minicart-recommendation-variant]'
    );

    if (!select) return;
    updateCardPrice(select);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(
      '[data-minicart-recommendation-add]'
    );

    if (!button) return;

    event.preventDefault();

    const card = button.closest(
      '[data-minicart-recommendation-card]'
    );

    if (!card || button.disabled) return;

    const variantId = Number(button.dataset.variantId || 0);
    const originalText = button.textContent;

    if (!variantId) {
      setCardMessage(
        card,
        'Please select an available option.',
        true
      );
      return;
    }

    button.disabled = true;
    button.textContent = 'ADDING…';
    setCardMessage(card);

    try {
      const addToCart = await waitForBluboltAddToCart();

      await addToCart(
        {
          id: variantId,
          quantity: 1
        },
        true
      );

      setCardMessage(card, 'Added to cart.');
      button.textContent = 'ADDED';

      /*
       * The React mini-cart refreshes through its own Redux cart update.
       * Remove the injected block so the observer can rebuild it using
       * the new cart contents.
       */
      window.setTimeout(() => {
        document
          .querySelector(
            CONFIG.selectors.recommendationSection
          )
          ?.remove();

        injectRecommendations();
      }, 700);
    } catch (error) {
      console.error(
        'Mini-cart recommendation add error:',
        error
      );

      button.disabled = false;
      button.textContent = originalText;

      setCardMessage(
        card,
        error?.message ||
          'The product could not be added.',
        true
      );
    }
  });

  let observerTimer = null;

  const observer = new MutationObserver(() => {
    window.clearTimeout(observerTimer);

    observerTimer = window.setTimeout(() => {
      injectRecommendations();
    }, 120);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', () => {
    injectRecommendations();
  });

  injectRecommendations();
})();
